"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require('./callout.css');const l="_callout_1i6z6_1",e={callout:l};exports.callout=l;exports.default=e;
//# sourceMappingURL=callout.module.css.cjs.map
